export default __webpack_public_path__ + "static/media/AmarjeetResume.0374372c.PDF";